<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="12" md="12" sm="12">
        <a class="back-button" @click="toggleNavigation">
          <v-icon color="#F99741">mdi-chevron-left</v-icon>Voltar</a
        >
      </v-col>

      <v-col cols="12" lg="12" md="12" sm="12" class="pt-5 pb-5 pl-2">
        <div class="d-flex">
          <div>
            <div class="filter-data-title">
              <span>Filtros</span>
            </div>
            <div>
              <span class="filter-data-sub-title"
                >Defina os filtros para visualizar os dados históricos.</span
              >
            </div>
          </div>
        </div>
      </v-col>

      <div class="data-hours-root">
        <div class="d-flex flex-row" style="">
          <v-switch
            v-model="isTime"
            hide-details
            inset
            label="Dados horários"
            color="#EFFFDC"
          ></v-switch>
        </div>

        <div class="d-flex pt-6 flex-column" style="align-items: flex-start">
          <span class="data-hours-title pr-2 pl-1">Tipo da visualização</span>
          <div class="py-2 pr-2 pl-1 graph-table-chip">
            <v-btn
              height="40"
              v-for="(btn, i) in typeHistoricalButtons"
              :key="i"
              :class="
                isSelectedTypeHistorical(btn)
                  ? 'historical-btn historical-btn-active'
                  : 'historical-btn'
              "
              @click="toggleTypeHistorical(btn)"
            >
              <v-icon
                size="14"
                class="pr-1"
                :color="isSelectedTypeHistorical(btn) ? 'primary' : 'accent'"
                >{{ btn.icon }}</v-icon
              >
              <span class="historical-btn-text"
                >{{ btn.name }} <br />
                {{ isTime ? btn.subtitleHourly : btn.subtitle }}</span
              >
            </v-btn>
          </div>
        </div>

        <div class="flex pt-5 pr-2 pl-1" style="z-index: 3">
          <div class="d-flex align-center">
            <label class="label-area">Área</label>
          </div>

          <div class="pt-1 d-flex">
            <div class="filter-input-group" style="width: 135px">
              <v-select
                class="text-field"
                dense
                color="accent"
                :items="regions"
                item-text="name"
                return-object
                v-model="regionSelected"
                id="selectReg"
                outlined
                background-color="accent"
                item-color="accent"
                @change="filterSelectedChange()"
              >
                <template #selection="{item}">
                  <span style="color: var(--v-secondary-base)">
                    {{ item.name }}
                  </span>
                </template>
                <template #append>
                  <v-icon color="secondary">icon-alertadis-angle-down</v-icon>
                </template>
              </v-select>
            </div>

            <div
              v-if="regionSelected.id == 1"
              class="filter-input-group-no-label pl-2"
              style="width: 165px"
            >
              <v-select
                class="text-field"
                dense
                color="accent"
                :items="regionalsList"
                item-text="fullname"
                v-model="regionalSelected"
                outlined
                background-color="secondary"
                item-color="accent"
                return-object
                append-icon="icon-alertadis-angle-down"
                @change="filterSelectedChange()"
              ></v-select>
            </div>

            <div
              v-if="regionSelected.id == 2"
              class="filter-input-group-no-label pl-2"
              style="width: 175px"
            >
              <v-autocomplete
                class="text-field select-style"
                dense
                color="accent"
                :items="agenciesList"
                v-model="agencieSelected"
                :item-text="(item) => `${item.name} - ${item.id}`"
                return-object
                outlined
                background-color="secondary"
                item-color="accent"
                append-icon="icon-alertadis-angle-down"
                @change="filterSelectedChange()"
              >
                <template #item="{item}">
                  {{ item.id }} {{ item.name }}
                </template>
                <template #selection="{item}">
                  {{ item.id }} {{ item.name }}
                </template>
              </v-autocomplete>
            </div>

            <div
              v-if="regionSelected.id == 3"
              class="filter-input-group-no-label pl-2"
              style="width: 165px; height: 36px"
            >
              <v-autocomplete
                class="text-field"
                dense
                color="accent"
                :items="countiesList"
                v-model="countieSelected"
                item-text="name"
                item-value="cityId"
                return-object
                outlined
                background-color="secondary"
                item-color="accent"
                append-icon="icon-alertadis-angle-down"
                :filter="filterCountie"
                @change="filterSelectedChange()"
              >
              </v-autocomplete>
            </div>
          </div>
        </div>

        <div>
          <v-tooltip
            max-width="200"
            bottom
            content-class="arrow tooltip-bottom"
            color="secondary lighten-3"
            v-if="isTime === true"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon size="16" v-bind="attrs" v-on="on" color="accent">
                icon-alertadis-info-circle
              </v-icon>
            </template>
            <span style="width: 50px">
              {{
                typeHistoricalSelected.id === 0
                  ? 'Hora de referência para exibição dos dados nos gráficos.'
                  : 'Hora a partir do qual os dados históricos serão considerados na tabela.'
              }}
            </span>
          </v-tooltip>
          <label
            class="pl-1 pt-1 label-hora"
            v-if="typeHistoricalSelected.id == 0 && isTime == true"
            >Hora</label
          >
          <label
            class="pl-1 pt-1 label-hora"
            v-if="typeHistoricalSelected.id == 1 && isTime == true"
            >Hora Inicial</label
          >
        </div>
        <div class="text-field-time pb-2">
          <v-menu
            v-model="menuDatePicker"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            v-if="isTime == true"
          >
            <template v-slot:activator="{on, attrs}">
              <div class="d-flex">
                <v-text-field
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="time"
                  dense
                  style="
                    border-radius: 8px;
                    border: 2px solid #191c29;
                    height: 40px;
                    width: 304px;
                  "
                  outlined
                  color="accent"
                  background-color="secondary"
                  v-if="isTime == true"
                ></v-text-field>
              </div>
            </template>
            <div class="d-flex">
              <div>
                <v-time-picker
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                  "
                  v-if="menuDatePicker"
                  :value="time"
                  no-title
                  v-model="time"
                  format="24hr"
                  @click:hour="closeTimePicker"
                ></v-time-picker>
              </div>
            </div>
          </v-menu>
        </div>
        <div
          class="d-flex align-center pt-3"
          v-if="typeHistoricalSelected.id == 1 && isTime == true"
        >
          <v-tooltip
            max-width="200"
            bottom
            content-class="arrow tooltip-bottom"
            color="secondary lighten-3"
          >
            <template v-slot:activator="{on, attrs}">
              <v-icon size="16" v-bind="attrs" v-on="on" color="accent"
                >icon-alertadis-info-circle</v-icon
              >
            </template>
            <span style="width: 50px"
              >Hora limite até o qual os dados históricos serão considerados na tabela.</span
            >
          </v-tooltip>

          <label class="pl-1 label-hora">Hora Final</label>
        </div>
        <div
          class="text-field-time pb-3"
          v-if="typeHistoricalSelected.id == 1 && isTime == true"
        >
          <v-menu
            v-model="menuDatePickerEnd"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{on, attrs}">
              <div class="d-flex">
                <v-text-field
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="timeEnd"
                  dense
                  style="
                    border-radius: 8px;
                    border: 2px solid #191c29;
                    height: 40px;
                    width: 304px;
                  "
                  outlined
                  color="accent"
                  background-color="secondary"
                ></v-text-field>
              </div>
            </template>
            <div class="d-flex">
              <div>
                <v-time-picker
                  style="
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                  "
                  v-if="menuDatePickerEnd"
                  :value="timeEnd"
                  no-title
                  v-model="timeEnd"
                  format="24hr"
                  @click:hour="closeTimePickeEnd"
                ></v-time-picker>
              </div>
            </div>
          </v-menu>
        </div>
        <v-divider style="background-color: #b0c0c7"></v-divider>

        <div class="d-flex pt-5 flex-column">
          <div>
            <span>LEGENDA</span>
          </div>

          <div class="d-flex pt-3">
            <v-btn fab x-small color="white">
              <v-icon color="#B94D8A">icon-alertadis-wind </v-icon>
            </v-btn>
            <span class="pl-2 pt-2 legend-font" style="color: #b94d8a">
              Acima de 55 km/h</span
            >
          </div>

          <div class="d-flex pt-1">
            <v-btn fab x-small color="white">
              <v-icon color="#3894AE">icon-alertadis-wi-rain</v-icon>
            </v-btn>
            <span class="pl-2 pt-2 legend-font" style="color: #3894ae">
              Acima de 40 mm</span
            >
          </div>
          <div class="d-flex pt-1">
            <v-btn fab x-small color="white">
              <v-icon color="#69BECD">$temperatureMin</v-icon>
            </v-btn>
            <span class="pl-2 pt-2 legend-font" style="color: #69becd"
              >Abaixo de 6ºC</span
            >
          </div>
          <div class="d-flex pt-1">
            <v-btn fab x-small color="white">
              <v-icon color="#C37323">$temperatureMax</v-icon>
            </v-btn>
            <span class="pl-2 pt-2 legend-font" style="color: #c37323">
              Acima de 34ºC</span
            >
          </div>

          <div class="d-flex pt-1">
            <v-btn fab x-small color="white">
              <v-icon color="#3D8EBB">icon-alertadis-bolt</v-icon>
            </v-btn>
            <span class="pl-2 pt-2 legend-font" style="color: #3d8ebb"
              >Ocorrência de raios</span
            >
          </div>
        </div>
      </div>

      <div
        class="calendar pl-4"
        v-show="typeHistoricalSelected.id == 1 && isTime == false"
      >
        <Calendar
          v-model="selectedDateRange"
          :selectedDateRange="selectedDateRange"
          :typeHistoricalSelected="typeHistoricalSelected"
          :dragSelection="dragSelection"
          :regionSelected="regionSelected"
          @drag="dragSelection = $event"
          :isTime="isTime"
          :filterSelected="filterSelected"
        >
        </Calendar>
      </div>

      <div
        class="calendar pl-4"
        v-show="typeHistoricalSelected.id == 1 && isTime == true"
      >
        <Calendar
          v-model="selectedDate"
          :selectedDate="selectedDate"
          :typeHistoricalSelected="typeHistoricalSelected"
          :regionSelected="regionSelected"
          :isTime="isTime"
          :filterSelected="filterSelected"
        >
        </Calendar>
      </div>

      <div class="calendar pl-4" v-show="typeHistoricalSelected.id == 0">
        <Calendar
          v-model="selectedDate"
          :selectedDate="selectedDate"
          :typeHistoricalSelected="typeHistoricalSelected"
          :regionSelected="regionSelected"
          :isTime="isTime"
          :filterSelected="filterSelected"
        >
        </Calendar>
      </div>

      <div class="btn-group p-5">
        <v-col class="d-flex align-center">
          <v-btn
            id="btn-add"
            color="accent lighten-1"
            large
            @click="filterChanged()"
          >
            <span>Aplicar</span>
          </v-btn>
          <v-btn
            id="btn-clean"
            outlined
            color="accent lighten-1"
            large
            @click="toggleNavigation"
          >
            <span>Cancelar</span>
          </v-btn>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import Calendar from '@/components/historical/Calendar.vue';
import moment from 'moment';
export default {
  components: {
    Calendar,
  },

  data: () => ({
    selectedDate: new Date(),
    selectedDateAux: new Date(),
    selectedDateRange: {
      start: new Date(moment().subtract(6, 'days').format('YYYY-MM-DD')),
      end: new Date(),
    },
    dragSelection: null,
    isTime: false,
    time: '00:00',
    timeEnd: '23:00',
    timeIntStart: 0,
    timeIntEnd: 23,
    timeInt: 0,
    menuDatePicker: false,
    menuDatePickerEnd: false,
    typeHistoricalButtons: [
      {
        id: 0,
        name: 'GRÁFICOS',
        icon: 'icon-alertadis-chart',
        subtitle: 'Até 1 dia',
        subtitleHourly: 'Até 1h',
      },
      {
        id: 1,
        name: 'TABELA',
        icon: 'mdi-file-table-box-outline',
        subtitle: 'Até 7 dias',
        subtitleHourly: 'Até 24h',
      },
    ],

    regions: [
      {id: 1, name: 'Regional'},
      {id: 2, name: 'Base de Serviço de Campo'},
      {id: 3, name: 'Município'},
    ],
    typeHistoricalSelected: {
      id: 0,
      name: 'GRÁFICOS',
      icon: 'icon-alertadis-chart',
      subtitle: 'Até 1 dia',
    },
    regionSelected: {id: 1, name: 'Regional'},
    regionalSelected: {id: 93, name: 'DOCOST', fullname: 'DOCOST', icon: ''},
    agencieSelected: {
      id: 'BSCCEL',
      name: 'Cascavel',
      regionalId: 93,
      regional: 'DOCOST',
    },
    countieSelected: {
      cityId: 4101051,
      name: 'Anahy',
      regionalId: 93,
      regional: 'DOCOST',
      ucQuantity: 1197,
      agencies: ['BSCCEL'],
    },

    stations: [
      {
        date: '2023-03-02',
        icon: '$temperatureMin',
        text: 'Abaixo de 6° C',
        color: '#69BECD',
      },
      {
        date: '2023-03-02',
        icon: '$temperatureMax',
        text: 'Acima de 6ºC',
        color: '#c37323',
      },
      {
        date: '2023-03-04',
        icon: 'icon-alertadis-bolt',
        text: 'Ocorrência de raios',
        color: '#3D8EBB',
      },
      {
        date: '2023-03-14',
        icon: 'icon-alertadis-wind',
        text: 'Acima de 55 km/h',
        color: '#b94d8a',
      },
      {
        date: '2023-03-05',
        icon: 'icon-alertadis-wi-rain',
        text: 'Acima de 40 mm',
        color: '#3894ae',
      },
    ],

    filterSelected: {},
  }),
  created() {
    this.selectedDate = new Date();
    this.selectedDateRange.start = new Date(
      moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm'),
    );
    this.selectedDateRange.end = new Date(moment().format('YYYY-MM-DD HH:mm'));
    this.filterSelectedChange();
  },

  async mounted() {
    await this.filterChanged();
  },

  watch: {
    typeHistoricalSelected() {
      this.selected = [];
    },
  },

  computed: {
    ...mapGetters(['regionalsList', 'agenciesList', 'countiesList']),
  },

  methods: {
    filterSelectedChange() {
      const filter = {};
      if (this.regionSelected.id == 1) {
        filter.location = this.regionalSelected;
        filter.type = 'regional';
      }

      if (this.regionSelected.id == 2) {
        filter.location = this.agencieSelected;
        filter.type = 'agency';
      }

      if (this.regionSelected.id == 3) {
        filter.location = this.countieSelected;
        filter.type = 'city';
        filter.location.id = this.countieSelected.cityId;
      }
      this.filterSelected = filter;
    },

    toggleTypeHistorical(item) {
      this.typeHistoricalSelected = item;
    },
    isSelectedTypeHistorical(item) {
      return this.typeHistoricalSelected.id === item.id;
    },
    filterCountie(item, queryText) {
      if (item.name) {
        return (
          item.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(queryText.toLowerCase()) ||
          item.name.toLowerCase().includes(queryText.toLowerCase())
        );
      }
    },
    closeTimePicker(v) {
      this.timeIntStart = v;
      v = v < 10 ? '0' + v : v;
      this.time = v + ':00';
      this.timeInt = v;

      this.menuDatePicker = false;
    },

    closeTimePickeEnd(v) {
      this.timeIntEnd = v;
      v = v < 10 ? '0' + v : v;
      this.timeEnd = v + ':00';
      this.menuDatePickerEnd = false;
    },
    toggleNavigation() {
      this.$emit('toggleNavigation');
    },

    filterChanged() {
      const filter = {
        periodId: this.isTime ? 2 : 1,
        type: null,
        location: null,
        date:
          this.typeHistoricalSelected.id == 0
            ? moment(this.selectedDate).format('YYYY-MM-DD')
            : this.isTime == true
            ? moment(this.selectedDate).format('YYYY-MM-DD')
            : this.selectedDateRange,
        hour: this.isTime ? this.timeInt : '',
        hourStart: this.isTime ? this.timeIntStart : '',
        hourEnd: this.isTime ? this.timeIntEnd : '',
        startDate: this.selectedDateRange ? this.selectedDateRange.start : null,
        endDate: this.selectedDateRange ? this.selectedDateRange.end : null,
        typeHistoricalSelected: this.typeHistoricalSelected.id,
      };

      if (this.regionSelected.id == 1) {
        //Filtro de Regionais
        filter.location = this.regionalSelected;
        filter.type = 'regional';
      }
      if (this.regionSelected.id == 2) {
        //Filtro de Agencias
        filter.location = this.agencieSelected;
        filter.type = 'agency';
      }

      if (this.regionSelected.id == 3) {
        filter.location = this.countieSelected;
        filter.type = 'countie';
      }

      if (filter.location) {
        //EMIT FILTER
        this.$emit('filterChanged', filter);
      }
      this.toggleNavigation();
      this.$emit('toggleTypeHistorical', this.typeHistoricalSelected);
    },
  },
};
</script>

<style scoped lang="scss">
.calendar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;
  isolation: isolate;
  width: 800px;
  height: 578px;
}
.back-button {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #f99741;
  z-index: 3;
}
.filter-data-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  color: #ffffff;
}
.filter-data-sub-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: #f2f2f2;
}

.data-hours-root {
  box-sizing: border-box;
  align-items: flex-start;
  padding: 16px;
  isolation: isolate;
  width: 336px;
  min-height: 700px;
  border: 1px solid #b0c0c7;
  border-radius: 8px;
  flex: none;
  order: 0;
  align-self: stretch;
}

.data-hours-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: #ffffff;
}

.graph-table-chip {
  border-radius: 8px;
  background-color: #1b1f2d;
}

.historical-btn {
  width: 116px;
  margin-left: 4px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
  border: 1px solid var(--v-accent-base);
  border-radius: 4px;
  background-color: var(--v-secondary-base) !important;
  text-transform: none;
  .historical-btn-icon {
    color: #bac2cf;
  }
  .historical-btn-text {
    color: var(--v-accent-base);
  }
}

.historical-btn-active {
  background-color: var(--v-accent-base) !important;
  border: 1px solid var(--v-accent-base);
  .historical-btn-icon {
    color: var(--v-primary-base);
  }
  .historical-btn-text {
    color: var(--v-primary-base);
  }
}
.label-area {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: #ffffff;
}

.filter-input-group {
  display: flex;
  flex-direction: column;
}

.text-field {
  border-radius: 8px;
}

.select-style {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding-left: 4px;
  /* identical to box height, or 133% */
}

.filter-input-group-no-label {
  display: flex;
  flex-direction: row;
  padding: 0px;
}

.legend-font {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #f2f2f2;
}

.legend-style-icon {
  border-radius: 50px;
}

.time {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 304px;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

.label-hora {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height, or 129% */
  color: #ffffff;
  letter-spacing: 0.75px;
}

.text-field-time {
  display: flex;
  flex-direction: row;
  border-radius: 8px;
}

.legend-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 304px;
  height: 164px;

  /* Inside auto layout */
  flex: none;
  order: 5;
  flex-grow: 0;
  z-index: 0;
}

.btn-group {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

#btn-add {
  text-transform: none;
  height: 50px;
  border-radius: 8px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

#btn-clean {
  padding: 16px 20px;
  text-transform: none;
  width: 101px;
  height: 50px;
  left: 40px;
  border-radius: 8px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
</style>
